import React, { useMemo } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";
import { formatPen } from "../../../../utils/finance/format";


const COLORS = ["#4F46E5", "#06B6D4", "#22C55E", "#F59E0B", "#EF4444", "#8B5CF6"];

export function FinancePieChart({ title, data, labelKey, valueKey }) {
  const parsedData = useMemo(() => {
    if (!data) return [];

    return data.map((item, index) => ({
      ...item,
      [valueKey]: Number(item[valueKey] || 0),
      fill: COLORS[index % COLORS.length],
    }));
  }, [data, valueKey]);

  if (!parsedData.length) return null;

  return (
    <Card sx={{ borderRadius: 3, height: 360 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <PieChart>
            <Pie
                data={parsedData}
                dataKey={valueKey}
                nameKey={labelKey}
                outerRadius={90}
                label={({ name, percent }) =>
                    `${name} ${(percent * 100).toFixed(1)}%`
                }
                />

            <Tooltip formatter={(v) => formatPen(v)} />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
